import React, { Component } from 'react';
import { connect } from 'react-redux';
import actions from '../actions/org-in-params.actions';
import { Col, Row, Form, Modal, Select, Input, Upload, Icon, DatePicker, TimePicker,Checkbox } from 'antd';
import { dspxGetChildrens } from '../helpers/dspx-utils'
import PhoneNumberInput from '../components/phone-input';
import IconCheckBox from '../components/icon-checkbox';
import { RubleIcon, EditDocumentIcon } from '../resource/icons';
import moment from 'moment';
import { fromDateStr } from '../helpers/utcDate';

const { TextArea } = Input;

const OrgInParamsForm = Form.create()(
	class extends React.Component {
		handleTimeStartChange = (val) => {
			const e = this.props.form.getFieldValue('executeTimeEnd')
			if(!e.isAfter(val)) {
				const ne = moment(val)
				if(ne.hour() == 23 && ne.minute() == 45) {
					this.props.form.setFieldsValue({ executeTimeEnd:  ne.set({'hour':0, 'minute': 0}) } )
				}
				else {
					this.props.form.setFieldsValue({ executeTimeEnd: ne.add(15,'m')} )
				}
			}
			//this.props.dispatch(actions.applyService(value));
		}

		handleTimeEndChange = (val) => {
			const s = this.props.form.getFieldValue('executeTimeStart')
			if(!s.isBefore(val)) {
				const ns = moment(val)
				if(!(ns.hour() == 0 && ns.minute() == 0)) {
					this.props.form.setFieldsValue({ executeTimeStart: ns.subtract(15,'m')} )
				}
			}
			//this.props.dispatch(actions.applyService(value));
		}

		render() {
			const { visible, onCancel, onCreate, form, fprops } = this.props;
			const { getFieldDecorator } = form;

			return (
				<Modal className='dspx-icon-header'
					width={350}
					visible={visible}
					title={<span><EditDocumentIcon style={{ height: 40 }}/>Входящие номер и дата</span>}
					onCancel={onCancel}
					onOk={onCreate} >
					<Form layout="vertical">
					{getFieldDecorator('Id', { initialValue: fprops.docId })(<Input type='hidden' />)}
					{getFieldDecorator('OrgId', { initialValue: fprops.orgId })(<Input type='hidden' />)}

					<Row gutter={8}>
						<Col span={12}>
								<div style={{fontWeight: 'bold', paddingBottom: 10}}>{fprops.orgName}</div>
						</Col>
					</Row>

						<Row gutter={8}>
						<Col span={12}>
								<Form.Item label="Номер">
									{getFieldDecorator('InNumber', {initialValue: fprops.inNumber,} )(
										<Input allowClear={true} />)}
								</Form.Item>
							</Col>
							<Col span={12}>
								<Form.Item label="Дата" >
										{getFieldDecorator('InDate', 
											{ initialValue: fprops.inDate ? moment(fprops.inDate) : null,})(
											<DatePicker style={{width:130}}
												allowClear={true}
												format="DD.MM.YYYY" />
										)}
								</Form.Item>
							</Col>
						</Row>
					</Form>
				</Modal>
			);
		}
	});

class OrgInParamsFormContainer extends Component {

	handleCancel = () => {
		this.formRef.props.form.resetFields();
		this.props.dispatch(actions.closeModal());
	}

	handleCreate = () => {
		const form = this.formRef.props.form;
		form.validateFields((err, values) => {
			if (err) return;	
			
			const v = {...values, 
				InNumber: values.InNumber.trim() != "" ? values.InNumber : null,
				InDate: values.InDate ? fromDateStr(values.InDate) : null,
			}
			console.log(v)
			
			form.resetFields();
			this.props.dispatch(actions.patchInParams(v));
			this.props.dispatch(actions.closeModal());
		});
	}

	saveFormRef = (formRef) => {
		this.formRef = formRef;
	}

	render() {

		return (
			<OrgInParamsForm
				wrappedComponentRef={this.saveFormRef}
				visible={this.props.modalVisible}
				dispatch={this.props.dispatch}
				onCancel={this.handleCancel}
				onCreate={this.handleCreate}
				fprops={this.props}
			/>
		)
	}
}

function mapStateToProps(state) {
	const { orgInParamsStore } = state;
	return orgInParamsStore;
}

export default connect(mapStateToProps)(OrgInParamsFormContainer);
